import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'info' | 'warning' | 'error';

export interface ToastMessage {
  id: number;
  message: string;
  type: ToastType;
  duration: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private nextId = 0;

  readonly toasts = signal<ToastMessage[]>([]);

  success(message: string): void {
    this.show(message, 'success', 3500);
  }

  info(message: string): void {
    this.show(message, 'info', 3500);
  }

  warning(message: string): void {
    this.show(message, 'warning', 4500);
  }

  error(message: string): void {
    this.show(message, 'error', 6000);
  }

  dismiss(id: number): void {
    this.toasts.set(this.toasts().filter((toast) => toast.id !== id));
  }

  private show(message: string, type: ToastType, duration: number): void {
    const id = ++this.nextId;
    this.toasts.set([...this.toasts(), { id, message, type, duration }]);

    setTimeout(() => this.dismiss(id), duration);
  }
}
